import React from 'react';
import { Form } from 'react-bootstrap';
import './MaterialCheckbox.css';

const MaterialCheckbox = ({ material, isChecked, onChange }) => {
  const handleChange = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onChange && onChange(e);
  };

  return (
    <Form.Check
      type="checkbox"
      label={material}
      checked={isChecked}
      onChange={handleChange}
      className="material-checkbox-custom"
    />
  );
};

export default MaterialCheckbox;



